export default __webpack_public_path__ + "static/media/Squares 2.663e0716.png";